// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___a2bd6987b8cd1f2cc6a","cls2":"SimplePaperPodcast-cls2___a009c7e0a8b7a2ee7c5 SimplePaperPodcast-cls1___a2bd6987b8cd1f2cc6a"};